<template>
  <div class="login-modal tabstart" tabindex="0">
    <h2 class="login-modal__heading">{{ $t("license_form").heading }}</h2>
    <p class="login-modal__text">
      <!-- {{ $t("license_form").text }} -->
      Wähle einen Zahlungsplan:
    </p>
    <div class="login-modal__button-group">
      <app-button
        @click="changeModal('app-payment')"
        size="big"
        text="12 Monate für 4,95 € / Monat"
        class="login-modal__button login-modal__button--0"
      ></app-button>
      <app-button
        @click="getLicense()"
        size="big"
        text="6 Monate für 6,65 € / Monat"
        class="login-modal__button login-modal__button--1"
      ></app-button>
      <app-button
        @click="getLicense()"
        size="big"
        text="1 Monat für 9,95 € / Monat"
        class="login-modal__button login-modal__button--1"
      ></app-button>
    </div>

    <p class="login-modal__text">
      Oder gib eine Lizenznummer ein:
    </p>
    <app-input-complex
      :autocompleteInput="'email'"
      :placeholder="$t('license_form').license_number"
      :text="licenseNumber"
      @inputEvent="licenseNumber = $event"
      @keyupEvent="loginOnEnterKey($event)"
      @blurEvent="checkEmail"
    ></app-input-complex>
    <app-button
      @click="getLicense()"
      size="big"
      :text="$t('license_form').button"
      class="login-modal__button"
    ></app-button>
    <app-button-x-round @click="toggleModal()"></app-button-x-round>
  </div>
</template>

<script>
import AppInputComplex from "@/components/Molecules/InputComplex.vue";
import AppButton from "@/components/Atoms/Button.vue";
import AppButtonXRound from "@/components/Atoms/ButtonXRound.vue";
// import AppFooterLink from "@/components/Molecules/FooterLink.vue";

export default {
  name: "appLoginForm",
  components: {
    AppInputComplex,
    AppButton,
    AppButtonXRound
    // AppFooterLink
  },
  data() {
    return {
      licenseNumber: "",
      placeholderIsSmall: false, // for password
      inputType: "password",
      password: ""
    };
  },
  methods: {
    loginOnEnterKey(e) {
      if (e.code === "Enter" || e.keyCode === 13) {
        this.getLicense();
      }
    },
    login() {
      this.email = this.email.trim(); // Remove whitespaces

      if (this.email === "") {
        if (this.password === "") {
          this.toggleAlert(
            this.$t("form_login_feedback")["no_email_no_password"]
          );
        } else {
          this.toggleAlert(this.$t("form_login_feedback")["no_email"]);
        }
        return;
      } else if (this.password === "") {
        this.toggleAlert(this.$t("form_login_feedback")["no_password"]);
        return;
      } else if (this.password.length < 6) {
        this.toggleAlert(this.$t("form_login_feedback")["wrong_password"]);
        return;
      }
      this.$store.dispatch("login", {
        email: this.email,
        password: this.password
      });
    },
    getLicense() {
      if (this.licenseNumber === "") {
        this.toggleAlert("Bitte gib eine Lizenznummer ein.");
        return;
      }
      this.$store.dispatch("getLicense", this.licenseNumber);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "sass/main.scss";
.login-modal {
  width: 46rem;
  padding: 3.5rem 5.5rem 5.5rem;
  // border-radius: $border-radius;
  border-radius: 1rem;
  font-family: $font-primary;
  color: $color-white;
  background-color: $color-black;

  @include respond(tab-port) {
    width: 50rem;
  }

  @include respond(phone) {
    width: min(414px, 100vw - 1.5rem);
    padding: 3.5rem 3rem 0;
  }

  &:focus {
    outline: none;
  }

  &__heading {
    color: $color-white;
    margin-bottom: 3.75rem;
    font-size: 3.2rem;
    line-height: 1.2;

    @include respond(phone) {
      font-size: 3.5rem;
    }
  }

  &__text {
    padding-top: 2rem;
    margin-bottom: 2.25rem;
    font-size: 2.2rem;
    line-height: 1.3;
    color: #aaa;

    // border-top: 1px solid #333;

    @include respond(phone) {
      padding-top: 0;
      font-size: 2.8rem;
      color: #ccc;
    }
  }

  &__button-group {
    padding-bottom: 2.5rem;
    // margin-top: 0rem;
    margin-bottom: 2.75rem;
    // border-bottom: 1px solid #333;
  }

  &__button {
    margin-top: 2.75rem;
    // margin-bottom: 5.5rem;
    width: 100%;
    height: 5rem;
    // height: 4.5rem;
    font-family: $font-primary-bold;
    // font-size: 2.6rem;
    font-size: 2.4rem;
    text-align: center;
    background-color: $color-primary-dark;

    @include respond(phone) {
      margin-top: 2rem;
      margin-bottom: 3.5rem;
      height: 6.5rem;
      font-family: $font-primary-bold;
      font-size: 3rem;
    }

    &--0 {
      margin-top: 1rem;
      margin-bottom: 2rem;
    }

    &--1 {
      background-color: #222;
      margin-top: 1rem;
      margin-bottom: 2rem;
    }
  }
}
</style>
